import { useState } from "react";
import "./FloatingButtons.css";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";
import { IoClose } from "react-icons/io5";

export default function FloatingButtons() {
  const [open, setOpen] = useState(true);

  return (
    <div className="floating-container">

      {open && (
        <div className="floating-buttons">

          <a href="tel:+919143167167" className="float-btn call">
            <FaPhoneAlt />
          </a>

          <a href="https://wa.me/919143167167" className="float-btn whatsapp">
            <FaWhatsapp />
          </a>

        </div>
      )}

      <div className="float-btn main-btn" onClick={() => setOpen(!open)}>
        <IoClose />
      </div>

    </div>
  );
}